var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeskStandart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 128,
    viewBox: "0 0 132 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91664 76.0066L0.000976562 74.9079V24.9883L1.91664 26.087V76.0066Z",
    fill: "#574F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.842 56.2577L127.927 55.1309V101.867L130.547 104.149L129.842 56.2577Z",
    fill: "url(#paint0_linear_2_31210)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1297 5.04205L39.2422 3.94336V50.6515L41.8621 52.9334L41.1297 5.04205Z",
    fill: "#392F26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9153 76.0066L1.4082 72.4852L39.2424 50.6523L41.1298 51.7792L1.9153 76.0066Z",
    fill: "url(#paint1_linear_2_31210)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91504 26.087L42.5099 2.64844V52.5399L1.91504 75.9785V26.087ZM3.32361 26.8758V73.6121L41.1296 51.7793V5.043L3.32361 26.8758Z",
    fill: "#2C2721"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6273 75.7246L131.194 52.3142L40.5949 0L0 23.4104L90.6273 75.7246Z",
    fill: "#EED8B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.627 75.7249L131.194 52.3145V53.8639L90.627 77.3024V75.7249Z",
    fill: "#D3A470"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6273 75.7244L0 23.4102V24.9877L90.6273 77.302V75.7244Z",
    fill: "#DFB27B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.627 77.3018L131.222 53.8633V103.755L90.627 127.193V77.3018ZM92.0355 78.0625V124.799L129.841 102.966V56.2297L92.0355 78.0625Z",
    fill: "#2C2721"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6276 127.222L88.7119 126.095V76.2031L90.6276 77.3018V127.222Z",
    fill: "#574F3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6273 78.8519L0 26.5377V24.9883L90.6273 77.3025V78.8519Z",
    fill: "#574F3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6272 127.221L90.1201 123.7L127.926 101.867L129.842 102.966L90.6272 127.221Z",
    fill: "url(#paint2_linear_2_31210)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1631 123.109L96.7692 119.869L98.6849 120.968L97.4172 121.7L97.2763 121.785L92.0364 123.137C92.0364 123.109 91.6702 123.109 91.1631 123.109Z",
    fill: "#605657"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31210",
    x1: 128.099,
    y1: 90.5037,
    x2: 126.893,
    y2: 101.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#372F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28241B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_31210",
    x1: 38.1992,
    y1: 53.1569,
    x2: 41.323,
    y2: 51.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524441"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_31210",
    x1: 125.091,
    y1: 103.898,
    x2: 129.639,
    y2: 101.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1716"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskStandart);
export default __webpack_public_path__ + "static/media/DeskStandart.5e1fd5707173a83039c2a2bc69069ec6.svg";
export { ForwardRef as ReactComponent };